import { BehaviorSubject }	from 'rxjs';
import { Component }				from '@angular/core';
import {
	AppState,
	ConfigService,
	StateService
}														from '../../';

@Component({
  selector: 		'electra-root',
  styleUrls: 		[ './electraDesktop.component.scss' ],
  templateUrl: 	'./electraDesktop.component.html'
})
export class ElectraDesktopComponent {
	menuState = '';

  get menuClass(): string {
    return this.configService.desktopClass + ' ' + this.configService.showMenuClass;
  }

	constructor(public configService: ConfigService, public stateService: StateService) {
    stateService.app.subscribe(data => { this.gotState(data); });
    
    //document.title = "test";
    console.log('Electra desktop component created');
	}

	gotState(state: AppState) {
		if (this.configService.mobile) {
			if (state.filter || state.legend) {
				this.menuState = 'partial';
			} else if (state.iab || state.more || state.about || state.terms) {
				this.menuState = 'full';
			} else {
				this.menuState = '';
			}
		} else {
			if (state.about || state.terms) {
				this.menuState = 'full';
			} else if (state.iab || state.more || state.filter || state.legend) {
				this.menuState = 'partial';
			} else {
				this.menuState = '';
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/electraDesktop/electraDesktop.component.ts